import React from 'react'

const SpecialInstruction = ({ order, name, content, type = "is-warning", padding = 'py-2' }) => (
  <div className={`column is-full ${padding}`}>
    <div className={`notification ${type} is-light`}>
      {/* eslint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: content }}></span>
    </div>
  </div>
);

export default SpecialInstruction;
